import { Component, Input } from '@angular/core';
import { PigQueryResult } from '../../../models';

@Component({
  selector: 'app-filter-result-item',
  templateUrl: './filter-result-item.component.html',
  styleUrls: ['./filter-result-item.component.scss']
})
export class FilterResultItemComponent {
  @Input() item?: PigQueryResult;

  constructor() { }

}
